/**
 * Oculus — the Ovid House mark: a Mirror-of-Venus glyph (ring + stem + crossbar,
 * tilted -16°) with a single ember iris. Replaces the retired Maison-direction
 * drawing (hairline ring + lacquer iris ring + Bodoni "O" glyph). Geometry is
 * fixed per the House redesign spec — always tilted -16°, flat ink (ivory)
 * strokes, exactly one ember element (the iris fill). Size via `size` (px);
 * colour is hardcoded on the paths (not token-driven) because the mark's
 * palette is invariant — it never recolors with theme or hover state.
 */
import type {CSSProperties} from 'react'

interface OculusProps {
    size?: number
    className?: string
}

export function Oculus({size = 32, className}: OculusProps) {
    return (
        <svg
            className={`ov-oculus${className ? ` ${className}` : ''}`}
            style={{'--s': `${size}px`} as CSSProperties}
            viewBox="0 0 64 64"
            aria-hidden="true"
        >
            <g transform="rotate(-16 32 32)">
                <circle cx="32" cy="24" r="15" fill="none" stroke="#EAE2D2" strokeWidth="2.5" />
                <path d="M32 39 L32 56" stroke="#EAE2D2" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M26 50 L38 50" stroke="#EAE2D2" strokeWidth="2.5" strokeLinecap="round" />
                <circle cx="32" cy="24" r="5.5" fill="#B4714C" />
            </g>
        </svg>
    )
}

export default Oculus
